import { Apps, FormatListBulleted } from "@mui/icons-material";
import { Divider, Grid, IconButton, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import ServiceCardItem from "../../Homepage Components/Trending Services/ServiceCardItem";
import ServiceCardItemFlat from "../../Homepage Components/Trending Services/ServiceCardItemFlat";
import { tokens } from "../../../store/tokens";

/**
 * Services.js and Offers.js were the same component with only the title
 * and one prop name different — same toggle, same grid, same (missing)
 * active-state styling. Pulled into one place so a fix here doesn't need
 * to be copy-pasted a second time.
 */
const ServiceListSection = ({ title, serviceListData = [] }) => {
  const [viewMode, setViewMode] = useState("grid");

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Stack direction="row" justifyContent={"space-between"} alignItems="center" sx={{ pb: 1.5 }}>
        <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
          {title}
        </Typography>

        {/* Previously the "grid" button was always outlined and the
            "list" button was always plain text, regardless of which mode
            was actually active — there was no way to tell which view you
            were looking at from the buttons themselves. */}
        <Stack direction="row" spacing={0.5}>
          <IconButton
            size="small"
            onClick={() => setViewMode("grid")}
            sx={{
              color: viewMode === "grid" ? tokens.color.teal : tokens.color.inkFaint,
              bgcolor: viewMode === "grid" ? tokens.color.tealLight : "transparent",
            }}
          >
            <Apps fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => setViewMode("list")}
            sx={{
              color: viewMode === "list" ? tokens.color.teal : tokens.color.inkFaint,
              bgcolor: viewMode === "list" ? tokens.color.tealLight : "transparent",
            }}
          >
            <FormatListBulleted fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>
      <Divider sx={{ mb: 2, borderColor: tokens.color.line }} />

      <Grid container spacing={2}>
        {serviceListData.map((data) =>
          viewMode === "list" ? (
            <Grid item xs={12} key={data.service_refer}>
              <ServiceCardItemFlat data={data} />
            </Grid>
          ) : (
            <Grid item xs={12} sm={6} md={4} key={data.service_refer}>
              <ServiceCardItem data={data} />
            </Grid>
          )
        )}
      </Grid>
    </Box>
  );
};

export default ServiceListSection;
